module.exports = __webpack_public_path__ + "static/media/bonus-points.3eebc0a2.wav";